import React from 'react';
import { AVATAR_SRC } from '../constants';

export default function ChatTypingIndicator() {
  return (
    <div className="message-row assistant-message">
      <div className="message-avatar" aria-hidden="true">
        <img src={AVATAR_SRC} alt="" decoding="async" />
      </div>
      <div className="message-stack">
        <div className="message-content message-content--typing">
          <div className="typing-indicator-wrap">
            <span className="typing-label">Po përgatit përgjigjen…</span>
            <div className="typing-shimmer" aria-hidden="true">
              <span />
              <span />
              <span />
            </div>
            <div className="typing-indicator" aria-hidden="true">
              <span />
              <span />
              <span />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
